import { useTranslation } from 'next-i18next';
import { Button, type ButtonProps } from '../button';
import { DefaultDialog, type DefaultDialogProps } from './DefaultDialog';
import { createDialogManager } from './utils';

/**
 * @returns {string}
 * @example
 * const id = alertDialog.open({
 * // ...
 * });
 * alertDialog.close(id);
 *
 * @returns {Promise<boolean>}
 * @example
 * const confirm = await alertDialog.openAsync({
 *  size: 'xs',
 *  header: {
 *    title: 'Hello',
 *    topSlot: '👋',
 *  },
 *  body: 'Welcome to ZEP QUIZ!',
 *  confirmText: 'Confirm',
 *  confirmIntent: 'strong',
 *  shouldCloseOnDimClick: false,
 * });
 * if (confirm) {
 *  console.log('confirmed');
 * }
 */
export const alertDialog = createDialogManager<AlertDialogProps>(options => <AlertDialog {...options} />);
export interface AlertDialogProps extends Omit<DefaultDialogProps, 'footer'> {
  confirmText?: string;
  confirmIntent?: ButtonProps['intent'];
}
export const AlertDialog = (props: AlertDialogProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    confirmText: confirmTextProp,
    confirmIntent = 'strong'
  } = props;
  const confirmText = confirmTextProp ?? t('common.alertDialog.confirmText');
  return <DefaultDialog onClose={props.onClose} size={props.size} className={props.className} header={props.header} body={<div className="px-lg max-mobile-lg:px-md">{props.body}</div>} footer={<Button className="w-full" size="md" intent={confirmIntent} onClick={() => props.onClose?.(true)}>
          {confirmText}
        </Button>} hasDrawerHandle={props.hasDrawerHandle} hasDim={props.hasDim} shouldCloseOnDimClick={props.shouldCloseOnDimClick} data-sentry-element="DefaultDialog" data-sentry-component="AlertDialog" data-sentry-source-file="AlertDialog.tsx" />;
};